import React, { useState, useEffect } from "react";
import { Modal, ConfigProvider, theme } from "antd";
import SelectPayChannel from "./SelectPayChannel";
import Payment from "./Payment";
import { ChainPayProps } from "@/index";
import { PayChannelProps } from "./SelectPayChannel";

export const ChainPay: React.FC<ChainPayProps> = (props) => {
  const { dark = false, onClose } = props;

  const [open, setOpen] = useState<boolean>(true);
  const [paySelect, setPaySelect] = useState<PayChannelProps>({
    value: "",
    code: "",
    link: "",
    iconName: "",
    countDown: 0,
    currency: "",
    orderNo: "",
    getChannelApiUrl: "",
    paymentComputed: false,
  });

  const handleClose = () => {
    onClose?.();
    setOpen(false);
  };

  useEffect(() => {
    document.documentElement.classList[dark ? "add" : "remove"]("dark");
  }, [dark]);

  return (
    <ConfigProvider
      theme={{
        cssVar: true,
        hashed: false,
        algorithm: dark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: "#D0E4F0",
          borderRadiusLG: 24,
          fontFamily: "OutfitNormal",
        },
        components: {
          Steps: {
            navContentMaxWidth: 300,
          },
          Modal: {
            contentBg: "transparent",
          },
          Select: {
            borderRadiusLG: 6,
          },
        },
      }}
    >
      <Modal
        centered
        width="100%"
        className="chainpay-root-container max-w-[550px] pb-0 rounded-[24px] !bg-[url('/src/assets/bg.png')] bg-contain bg-no-repeat bg-white"
        open={open}
        maskClosable={false}
        footer={null}
        onCancel={handleClose}
      >
        <div className="flex flex-col px-[17px] sm:px-0">
          <h3 data-font="bold" className="flex text-[28px] font-[800] m-0">
            ChainPay
          </h3>

          {paySelect.value && (
            <Payment
              {...props}
              channel={paySelect.value}
              iconName={paySelect.iconName as string}
              countDown={paySelect.countDown}
              orderNo={paySelect.orderNo}
              currency={
                paySelect.value === "huione"
                  ? paySelect.currency
                  : props.currency
              }
              getChannelApiUrl={paySelect.getChannelApiUrl}
              isQrCode={paySelect.value === "huione"}
              code={paySelect.code}
              link={paySelect.link}
              onComputed={() => {
                setPaySelect({
                  ...paySelect,
                  paymentComputed: true,
                });
              }}
              onBack={(close = false) => {
                setPaySelect({
                  value: "",
                  code: "",
                  link: "",
                  iconName: "",
                  countDown: 0,
                  currency: "",
                  orderNo: "",
                  getChannelApiUrl: "",
                  paymentComputed: false,
                });
                if (close) handleClose();
              }}
            />
          )}
          {!paySelect.paymentComputed && paySelect.value !== "huione" && (
            <SelectPayChannel {...props} onPayChannelChange={setPaySelect} />
          )}
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ChainPay;
